import React, { useState, useRef, useEffect } from "react";
import editIcon from "../../../assets/images/editIcon02.png"
import saveIcon from "../../../assets/images/Check.svg";
import clearIcon from "../../../assets/images/X.svg";

const InputField = ({
  name,
  id,
  onChange,
  defaultValue,
  placeholder,
  type,
  maxAllowed,
  minAllowed,
  required,
  customStyle,
  isReadOnly=false,
  showEditIcon=false,
  saveEdit,
  fieldCustomStyle,
  editCustomStyle,
  editSaveCustomStyle,
  isLocationInput=false,
  focusChange,
  ref,
  onInputBlur,
  resetPhoneError=() => {},
  dataId="",
  disabled=false,
  isEventPage=false,
  customRegexValidation="",
  onEditClick,
  onCancelEdit,
  label,
  onFieldBlur
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [updatedVal, setUpdatedVal] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    setUpdatedVal(defaultValue);
  }, [defaultValue])
  

  let notEditable = false;
  if (isReadOnly && !showEditIcon) {
    notEditable = true;
  }
  const onInputChange = (e) => {
    if(customRegexValidation) {
      const isValidInput = customRegexValidation.test(e.target.value);
      if(!isValidInput) {
        return ;
      }
    }
    setUpdatedVal(e.target.value)
    if (showEditIcon) {
      return
    }
    onChange(id, e.target.value)
  }

  const onSaveEdit = () => {
    if (defaultValue === updatedVal) {
      setIsEditable(false);
    } else {
      const isValueEdited = Boolean(defaultValue);
      saveEdit(id, updatedVal, isValueEdited, name)
      setIsEditable(false);
    }
  }

  const fieldType = () => {
    if (!type) {
      return 'string';
    } else if (type === 'float') {
      return 'number';
    } else {
      return type;
    }
  }

  const inputBlurCallback = (phoneError) => {
    setTimeout(() => {
      if(showEditIcon && phoneError) {
        setIsEditable(true);
      }
    }, 500);
  }

  const onBlur= (e) => {
    if (onFieldBlur && isEditable) {
      const next = e.relatedTarget;
      const isSaveOrCancel =
        next?.alt === "save edit" ||
        next?.alt === "clear edit" ||
        next?.closest(".save-cancel-wrapper");

      const clickedInsideSaveCancel =
        e.currentTarget.parentElement?.querySelector(".save-cancel-wrapper")?.contains(document.activeElement);

      if (!isSaveOrCancel && !clickedInsideSaveCancel) {
        onFieldBlur();
      }
    };

    if (onInputBlur) {
      onInputBlur(id, e.target.value, type, inputBlurCallback);
    }
  }

  useEffect(() => {
    if (isEditable && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditable]);

  const handleCancel = async() => {
    if (onCancelEdit) await onCancelEdit();
    setUpdatedVal(defaultValue);
    setIsEditable(false);
    if (inputRef.current) {
      inputRef.current.value = defaultValue;
    }
    resetPhoneError();
  }

  return (
    <div
      className={`flex ${showEditIcon ? "justify-between" : "justify-start"}`}
    >
      {isLocationInput === false ? (
        <input
          ref={inputRef}
          type={fieldType()}
          id={id}
          className={`text-sm disabled:text-grayNobel placeholder-grayNobel text-tileGray font-normal h-4 mt-2 border-none w-full outline-none ${customStyle} ${fieldCustomStyle} ${isEventPage && showEditIcon && !isEditable && "cursor-pointer"}`}
          name={name}
          autoComplete={"off"}
          defaultValue={defaultValue}
          minLength={minAllowed}
          maxLength={maxAllowed}
          max={type === "float" && "999"}
          placeholder={placeholder}
          step={type === "float" && "0.01"}
          required={required}
          readOnly={notEditable || (showEditIcon && !isEditable)}
          onChange={(e) => {
            onInputChange(e);
          }}
          onBlur={(e) => onBlur(e)}
          disabled={disabled}
          onClick={() => isEventPage && showEditIcon && setIsEditable(true)}
          title={disabled ? 'Field cannot be edited' : ''}
          value={updatedVal}
        />
      ) : (
        <input
          ref={ref}
          onFocus={focusChange}
          type={fieldType()}
          id={id}
          className={`text-sm placeholder-grayNobel text-tileGray font-normal h-4 mt-2 border-none w-full outline-none ${customStyle} ${fieldCustomStyle}`}
          name={name}
          autoComplete={"new-password"}
          defaultValue={defaultValue}
          minLength={minAllowed}
          maxLength={maxAllowed}
          max={type === "float" && "999"}
          placeholder={placeholder}
          step={type === "float" && "0.01"}
          required={required}
          readOnly={notEditable || (showEditIcon && !isEditable)}
          onBlur={(e) => onBlur(e)}
          onChange={(e) => {
            onInputChange(e);
          }}
          data-id={dataId}
          disabled={disabled}
          title={disabled ? 'Field cannot be edited' : ''}
          value={updatedVal}
        />
      )}

      {!isEventPage && showEditIcon && !isEditable && (
        <button
          type="button"
          aria-label="edit"
          data-action="edit"
          className={`ml-ten -mt-4 ${editCustomStyle}`}
          onClick={() => {
            setIsEditable(true);
            if (onEditClick) onEditClick(label, true);
          }}
        >
          <img src={editIcon} alt="edit" className="h-4 w-4 cursor-pointer" />
        </button>
      )}
      {isEditable && (
        <div className={`grid -mt-5 ml-2 gap-2 save-cancel-wrapper ${editSaveCustomStyle}`}>
          <button
            type="button"
            aria-label="save edit"
            data-action="save"
            className="w-4 h-4 cursor-pointer"
            onClick={() => { onSaveEdit(); }}
          >
            <img src={saveIcon} alt="save edit" />
          </button>

          <button
            type="button"
            aria-label="clear edit"
            data-action="cancel"
            className="w-4 h-4 cursor-pointer"
            onClick={() => { handleCancel(); }}
          >
            <img src={clearIcon} alt="clear edit" />
          </button>
        </div>
      )}
    </div>
  );
}

export default InputField;
